<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!-- total selected tickets is: etc.totalTickets
	 per type count is: etc.typesInCollection.get(etc.currentType).count -->
Editing {{ typeCounts[currentType] }} out of {{ totalTickets }} tickets selected.
<div class="multi-edit__masthead-sub-title" automationId="changesAffectAllSelectedTickets">
	Changes affect all selected tickets.
</div>
